async function refresh(refreshToken: string) {
  const response = await fetch(`${import.meta.env.VITE_APP_URL}/auth/refresh`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      refresh_token: refreshToken,
    }),
  })

  const hasError = !response.ok
  const result = await response.json()

  return { response, result, hasError }
}

export default refresh
